import type { UpdateLicense } from '@wf-coe/types';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';
import type { LicenseDto } from './use-licenses.js';

interface UpdateLicenseInput {
  clientId: string;
  licenseId: string;
  patch: UpdateLicense;
}

/** Mutation for `PUT /v1/clients/{clientId}/licenses/{licenseId}`. */
export function useUpdateLicenseMutation(): UseMutationResult<
  LicenseDto,
  Error,
  UpdateLicenseInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, licenseId, patch }: UpdateLicenseInput) => {
      if (!api) throw new Error('useUpdateLicenseMutation: api client unavailable');
      return api.put<LicenseDto>(`/v1/clients/${clientId}/licenses/${licenseId}`, patch);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['licenses', clientId] });
    },
  });
}
